module.exports = __webpack_public_path__ + "static/the-elements-of-new-testament-greek-ed3e5767609e5d2a141246542fdf8c70.jpg";